import React, { useEffect, useRef } from 'react'
import animation from '../../../images/renshin-animation.webm'

// The source clip runs 1.03s. A light speed-up trims the loader further
// while keeping the motion readable; HOLD_DURATION is sized to match it.
export const ANIMATION_SPEED = 1.25

function LoaderAnimation() {
    const video = useRef(null)

    useEffect(() => {
        const player = video.current

        if (player) {
            player.playbackRate = ANIMATION_SPEED

            const promise = player.play()

            if (promise !== undefined) {
                promise.catch(() => {})
            }
        }
    }, [])

    return (
        <video ref={video} autoPlay muted playsInline preload='auto' data-keepplaying='data-keepplaying'>
            <source src={animation} type='video/webm' />
        </video>
    )
}

export default LoaderAnimation
